import React, { useState, useRef } from "react";
import {
  Container,
  Grid,
  Divider,
  TextField,
  Typography,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import CookieConsent from "react-cookie-consent";

import YoutubeEmbed from "./Components/YoutubeEmbed";

import video from "../../yt_url.json";

const useStyles = makeStyles((theme) => ({
  subscriber: {
    position: "fixed",
    top: 70,
    right: 10,
    fontWeight: 700,
    fontSize: 30,
    [theme.breakpoints.down("lg")]: {
      position: "absolute",
      fontSize: 24,
    },
  },
  container: {
    width: "100%",
    position: "relative",
    top: "70px",
    paddingTop: "10px",
    marginBottom: theme.spacing(4),
    paddingBottom: theme.spacing(2),
  },
  search: {
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
  filteredSearch: {
    marginBottom: theme.spacing(5),
  },
  divButton: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  loadButton: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    fontWeight: 700,
    padding: theme.spacing(2),
  },
}));

export default function Videos() {
  const classes = useStyles();
  const [filteredData, setFilteredData] = useState([]);
  const query = useRef();
  const [loadVideo, setLoadVideo] = useState(10);

  const handleLoad = () => {
    setLoadVideo(loadVideo + 10);
  };

  const handleSearch = (event) => {
    event.preventDefault();
    const searchWord = query.current.value ? query.current.value : "";
    if (searchWord === "") {
      setFilteredData([]);
    } else {
      const newFilter = video.filter((value) => {
        return value.title.toLowerCase().includes(searchWord.toLowerCase());
      });
      setFilteredData(newFilter);
    }
  };

  return (
    <div style={{ marginBottom: 20 }}>
      <Typography variant="body1" align="right" className={classes.subscriber}>
        Subscribers: <br />
        2.43k
      </Typography>
      <Container maxWidth="lg" className={classes.container}>
        <form onSubmit={handleSearch}>
          <TextField
            type="text"
            placeholder="Search Videos"
            variant="outlined"
            inputRef={query}
            className={classes.search}
          />
        </form>
        <Divider className={classes.divider} />
        <CookieConsent
          location="bottom"
          cookieName="youtubeCookie"
          style={{ background: "#2B373B" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={365}
        >
          This page uses cookies from YouTube to enhance the user experience.
        </CookieConsent>
        {filteredData.length !== 0 && (
          <div className={classes.filteredSearch}>
            <Typography variant="h4">Search Results</Typography>
            <Grid container spacing={2}>
              {filteredData.map((value, index) => (
                <Grid key={index} item xs={12} lg={6}>
                  <YoutubeEmbed embedId={value.yt_id} />
                  <Typography variant="body1" align="center">
                    {value.title}
                  </Typography>
                </Grid>
              ))}
            </Grid>
            <Divider style={{ marginTop: 30 }} />
          </div>
        )}
        <Typography variant="h4">List of Videos</Typography>
        <Grid container spacing={2}>
          {video.slice(0, loadVideo).map((data) => (
            <Grid key={data.id} item xs={12} lg={6}>
              <YoutubeEmbed embedId={data.yt_id} />
              <Typography variant="body1" align="center">
                {data.title}
              </Typography>
            </Grid>
          ))}
        </Grid>
        <div className={classes.divButton}>
          <Button
            variant="contained"
            className={classes.loadButton}
            onClick={handleLoad}
            disabled={video.length < loadVideo}
          >
            Load More
          </Button>
        </div>
      </Container>
    </div>
  );
}
